import { useQuery } from 'react-query';
import { TypeCustomStructuredActivityFields } from 'types/contentful/clinical';
import { api } from 'domains/api';
import { BASE_ANONYMOUS_API_ROUTES, getBaseAPIRoute } from 'domains/api/base/routes';

export const getCustomStructuredActivity = (activityId: string): Promise<TypeCustomStructuredActivityFields> => {
  return api.baseAnonymous
    .get<TypeCustomStructuredActivityFields>(
      getBaseAPIRoute(BASE_ANONYMOUS_API_ROUTES.clients['custom-structured-activity'][':activityId'].get, {
        activityId,
      }),
    );
};

export const useCustomStructuredActivity = (activityId: string) => {
  return useQuery(['custom-structured-activity', activityId], () =>
    getCustomStructuredActivity(activityId),
  );
};
